import { StyleSheet, View, Text } from "react-native";
import Icon from "./icons/CustomIcon";
import { levelLabels } from "@podcasts/constants";

export default function UserLevel({ level = levelLabels.BEGINNER }) {
  return (
    <View style={styles.level_box}>
      <Icon
        name="rocket"
        size={14}
        color="#F51D00"
        style={{ marginRight: 8 }}
      />
      <View style={styles.level_info}>
        <Text style={[styles.level_text, {fontFamily: 'SofiaProBold' }]}>Level: </Text>
        <Text style={[styles.level_text, {fontFamily: 'SofiaPro' }]}>{level}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  level_box: {
    backgroundColor: "#fff",
    paddingHorizontal: 10,
    paddingVertical: 9,
    borderRadius: 5,
    flexDirection: "row",
    flexBasis: "auto",
    alignSelf: "flex-start",
    alignItems: "center",
    marginTop: 15,
    marginBottom: 20,
  },
  level_info: {
    flexDirection: "row",
    alignItems: "center",
  },
  level_text: {
    color: "#021C3C",
    fontSize: 12,
    lineHeight: 12,
  },
});
